import { Component, OnDestroy, OnInit } from "@angular/core";
import { OperationHistoryEsEnum } from "@edp-enums/ES/operation-history-es-enum";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { OrderEs } from "@edp-models/ES/es-order.model";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { GetOrderEs } from "@edp-store/actions/ES/order-es.actions";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { getOrderEs } from "@edp-store/selectors/ES/order-es.selectors";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { Store, select } from "@ngrx/store";
import moment from "moment";
import { Subject, combineLatest } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

@Component({
    selector: "edp-es-widget-order",
    templateUrl: "./edp-es-widget-order.component.html",
    styleUrls: ["./edp-es-widget-order.component.scss"],
})
export class EdpEsWidgetOrderComponent implements OnInit, OnDestroy {
    public order: OrderEs;
    private contract: ContractEs;
    public dateFormatted: string;
    private unsubscribe = new Subject();

    constructor(
        private storeEs: Store<IAppEsState>,
        private readonly operationHistoryService: OperationHistoryService,
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.storeEs.pipe(
                select(getContractEs),
                filter(c => !!c)
            ),
            this.storeEs.pipe(select(getOrderEs)),
        ])
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(([contract, order]) => {
                if (!!order && order.contractId === contract.id) {
                    this.order = order;
                    this.contract = contract;
                    this.sendOperationHistory(this.order.indexStepActive);
                    this.dateFormatted = moment(order.date).format("DD MMM");
                    return;
                }
                this.storeEs.dispatch(new GetOrderEs(contract.id));
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    private sendOperationHistory(stage: number) {
        switch (stage) {
            case 1:
                this.sendOperationHistoryService(OperationHistoryEsEnum.STAGE_TECHNICALVERIFICATION);
                break;
            case 2:
                this.sendOperationHistoryService(OperationHistoryEsEnum.STAGE_SOLARINSTALLATION);
                break;
            case 3:
                this.sendOperationHistoryService(OperationHistoryEsEnum.STAGE_REGISTER);
                break;
        }
    }

    private sendOperationHistoryService(key: string, value: string | null = null) {
        this.operationHistoryService.registerWithContract(this.contract.id, key, value, null, null, false);
    }

}
